import { gql } from '@apollo/client'

import { CHAT_CUSTOMER_FRAGMENT } from 'Const'

export const SIGN_UP = gql`
  mutation SignUp($input: SignUpCustomerInput) {
    signUpCustomer(input: $input) {
      user {
        customer {
          ...ChatCustomer
        }
      }
    }
  }
  ${CHAT_CUSTOMER_FRAGMENT}
`
